import { initGlobalState } from 'qiankun'

export const subscribeState = (stateObj: {sidebar_status: boolean}) => {
  initGlobalState({
    sidebar_status: stateObj.sidebar_status
  })
}
